import type { HouseholdRole } from "../types/household"
import { apiRequest } from "./apiClient"

interface SendInvitationResponse {
  success: boolean
  invitationId: string
  emailSent: boolean
  error?: string
}

export interface InvitationResult {
  success: boolean
  invitationId?: string
  emailSent?: boolean
  error?: string
}

/**
 * Service for managing household invitations via the Edge Functions API.
 */
class InvitationService {
  async sendInvitation(
    householdId: string,
    householdName: string,
    invitedEmail: string,
    invitedByName: string,
    role: HouseholdRole,
  ): Promise<InvitationResult> {
    try {
      const result = await apiRequest<SendInvitationResponse>("/api/invitations", {
        method: "POST",
        body: {
          householdId,
          householdName,
          invitedEmail,
          invitedByName,
          role: role as "administrator" | "family_member",
        },
      })
      return {
        success: result.success,
        invitationId: result.invitationId,
        emailSent: result.emailSent,
        error: result.error,
      }
    } catch (error) {
      return { success: false, error: error instanceof Error ? error.message : "Failed to send invitation" }
    }
  }
}

export const invitationService = new InvitationService()
export default invitationService
